import React, { useState } from "react";
import {
    Card,
    Grid,
    Button,
    Chip,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import apiRequest from "../../../../apiRequest";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog";

const TaxInfoCard = ({
    taxInfo,
    loading,
    handleTaxAction,
    setSelectedId,
    setActionType,
    setReasonModalOpen,
    setPreviewImage,
    setPreviewOpen,
}) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmData, setConfirmData] = useState(null);

    if (!taxInfo) {
        return (
            <Card sx={{ p: 3, minHeight: 250 }}>
                <MDBox
                    height="100%"
                    minHeight={200}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <MDTypography variant="body1" color="text.secondary">
                        No data found
                    </MDTypography>
                </MDBox>
            </Card>
        );
    }

    const handleApproveClick = () => {
        setConfirmData(taxInfo.id);
        setConfirmOpen(true);
    };

    const handleConfirmApprove = async () => {
        setConfirmOpen(false);
        await handleTaxAction(taxInfo.id, "approved", "Approved by Admin");
    };

    return (
        <Card sx={{ p: 3, minHeight: 250 }}>
            <MDTypography variant="h6" mb={2}>
                Tax Info
            </MDTypography>

            <Grid container spacing={2}>
                {/* Business Number */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Business Number</MDTypography>
                    <MDTypography variant="body2">
                        {taxInfo.business_number || "-"}
                    </MDTypography>
                </Grid>

                {/* Work Eligibility */}
                <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Work Eligibility</MDTypography>
                    <MDTypography variant="body2">
                        {taxInfo.work_eligibilty || "-"}
                    </MDTypography>
                </Grid>

                {/* Status */}
                {/* <Grid item xs={12} md={6}>
                    <MDTypography variant="caption">Status</MDTypography>
                    <MDBox mt={0.5}>
                        <Chip
                            label={taxInfo.status}
                            size="small"
                            color={
                                taxInfo.status === "approved"
                                    ? "success"
                                    : taxInfo.status === "rejected"
                                        ? "error"
                                        : "warning"
                            }
                        />
                    </MDBox>
                </Grid> */}


                {/* Reason */}
                {taxInfo.reason && (
                    <Grid item xs={12} md={6}>
                        <MDTypography variant="caption">Reason</MDTypography>
                        <MDTypography variant="body2">{taxInfo.reason}</MDTypography>
                    </Grid>
                )}

                {/* PR Document */}
                {taxInfo.pr_photo && (
                    <Grid item xs={12} md={6}>
                        <MDTypography variant="caption">PR Document</MDTypography>
                        <MDBox
                            mt={1}
                            sx={{
                                width: 160,
                                height: 120,
                                borderRadius: 2,
                                overflow: "hidden",
                                border: "1px solid #e0e0e0",
                                cursor: "pointer",
                                "&:hover img": { transform: "scale(1.05)" },
                            }}
                            onClick={() => {
                                setPreviewImage(`${apiRequest.BASE_URL}/${taxInfo.pr_photo}`);
                                setPreviewOpen(true);
                            }}
                        >
                            <MDBox
                                component="img"
                                src={`${apiRequest.BASE_URL}/${taxInfo.pr_photo}`}
                                alt="PR Document"
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transition: "transform 0.3s ease",
                                }}
                            />
                        </MDBox>
                    </Grid>
                )}
            </Grid>

            {/* ACTION BUTTONS */}
            <MDBox mt={3} display="flex" gap={1.5} justifyContent="flex-end">
                {/* Approve */}
                <Button
                    variant="outlined"
                    disabled={loading || taxInfo.status === "approved"}
                    onClick={handleApproveClick} // ✅ Open confirm dialog first
                    sx={{
                        bgcolor: "#fff",
                        color: "#2e7d32",
                        borderColor: "#2e7d32",
                        "&:hover": { bgcolor: "#f5f5f5", borderColor: "#1b5e20" },
                    }}
                >
                    Approve
                </Button>

                {/* Reject */}
                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedId(taxInfo.id);
                        setActionType("rejected");
                        setReasonModalOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#d32f2f",
                        borderColor: "#d32f2f",
                        "&:hover": { bgcolor: "#f5f5f5", borderColor: "#b71c1c" },
                    }}
                >
                    Reject
                </Button>

                {/* Request Info */}
                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedId(taxInfo.id);
                        setActionType("request_info");
                        setReasonModalOpen(true);
                    }}
                    sx={{
                        bgcolor: "#fff",
                        color: "#ed6c02",
                        borderColor: "#ed6c02",
                        "&:hover": { bgcolor: "#f5f5f5", borderColor: "#e65100" },
                    }}
                >
                    Request Info
                </Button>
            </MDBox>

            {/* CONFIRM DIALOG */}
            <ConfirmDialog
                open={confirmOpen}
                title="Approve Tax Info"
                description={`Are you sure you want to approve this tax info?`}
                confirmText="Yes, Approve"
                confirmColor="success"
                loading={loading}
                onClose={() => setConfirmOpen(false)}
                onConfirm={handleConfirmApprove}
            />
        </Card>
    );
};

export default TaxInfoCard;
